<template>
    <div id="">
        <el-form :model="subData" :rules="rules" ref="subData" label-width="80px">
            <el-form-item label="账号">
                <el-input v-model.trim="subData.account" placeholder="请输入用户名" v-filter-special-char="subData.account" readonly> </el-input>
            </el-form-item>
            <el-form-item label="旧密码" prop="originalPassword">
                <el-input v-model.trim="subData.originalPassword" placeholder="请输入密码" type="password" v-filter-special-char="subData.originalPassword"> </el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-input v-model.trim="subData.newPassword" placeholder="请输入密码" type="password" v-filter-special-char="subData.newPassword"> </el-input>
            </el-form-item>
            <el-form-item>
                <password-line :passwordVal="subData.newPassword"></password-line>
            </el-form-item>
            <el-form-item label="确认密码" prop="rePassword">
                <el-input v-model.trim="subData.rePassword" placeholder="请输入密码" type="password" v-filter-special-char="subData.rePassword"> </el-input>
            </el-form-item>
            <div style="text-align: right">
                <el-button class="login-btn" @click="clearDialog">取消</el-button>
                <el-button class="login-btn btn-primary" @click="submitForm()">确定</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import passwordLine from '@/components/common/checkPassword';
export default {
    name: '',
    components: { passwordLine },
    data() {
        let validateRePassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.subData.newPassword) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            subData: {
                userId: userMsg.EmployeeId,
                account: userMsg.Account,
                originalPassword: '',
                newPassword: '',
                rePassword: ''
            },
            rules: {
                originalPassword: [{ required: true, message: '请输入正确的原始密码', trigger: 'blur' }],
                password: [{ newPassword: true, message: '请输入新密码', trigger: 'blur' }],
                rePassword: [{ validator: validateRePassword, trigger: 'blur' }]
            }
        };
    },
    mounted() {},
    methods: {
        resetForm() {
            this.$util.clearValidate(this, 'subData');
            this.subData = {
                userId: this.userMsg.EmployeeId,
                account: this.userMsg.Account,
                originalPassword: '',
                newPassword: '',
                rePassword: ''
            };
        },
        clearDialog() {
            this.$emit('clearDialog');
        },
        // 修改密码
        submitForm() {
            if (this.subData.newPassword.length < 6) {
                this.$util.warningMsg('密码长度不能小于6位');
                return;
            }
            this.$refs.subData.validate(valid => {
                if (valid) {
                    this.$util
                        .axiosPost({
                            url: '/api/EntpInfoManagement/ChangePassword',
                            data: this.subData
                        })
                        .then(res => {
                            this.$util.successMsg('修改密码成功');
                            this.$emit('clearDialog');
                        });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang="less" scoped></style>
